import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/notifications/selectors';

export const getState = createSelector(getParent, ({ data } = {}) => data);
